/*
 * @Author: v_smwang
 * @Date: 2020-07-29 16:20:30
 * @LastEditors: v_smwang
 * @LastEditTime: 2020-08-01 15:25:54
 * @FilePath: \src\store\index.js
 * @Description: 描述
 * @Module: 模块路径
 */
import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import user from './modules/user';
import permission from './modules/permission';
import personnelPortraitOverview from './modules/personnelPortraitOverview';
import personnelWorkHourOverview from './modules/personnelWorkHourOverview';
import personnelWorkHourDetail from './modules/personnelWorkHourDetail';
import personnelWorkHour from './modules/personnelWorkHour';
import getters from './getters';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    personnelPortraitOverview,
    personnelWorkHour,
    personnelWorkHourOverview,
    personnelWorkHourDetail,
  },
  state: {

  },
  mutations: {

  },
  actions: {

  },
  getters,
});
